import React, { useEffect } from "react";
import useAllBookmarksQuery from "utilities/hooks/queries/my-link/bookmarks/all-bookmarks/use-all-bookmarks-query";
import { t } from "utilities/localization-utils";
import BookmarkDetailPageSidebar from "./bookmark-detail-page-sidebar";
import { Icons } from "atoms/constants/icons";
import SortBy from "../../options/sort-by";
import useSortBookmarks from "utilities/hooks/domain/my-link/use-sort-bookmarks";
import usePagedResultsFromParams from "utilities/hooks/use-paged-results-from-params";
import useFilterBookmarks from "utilities/hooks/domain/my-link/use-filter-bookmarks";
import useSearchBookmarks from "utilities/hooks/domain/my-link/use-search-bookmarks";
import FilterByShareStatus from "organisms/my-link/my-bookmarks-dashboard/options/filter-by-share-status";
import SearchBookmarks from "organisms/my-link/my-bookmarks-dashboard/options/search-bookmarks";
import UserBookmarkShareFilterOption from "models/enumerations/filtering/user-bookmarks/user-bookmark-share-filter-option";

interface SidebarForAllProps {}

const SidebarForAll = (props: SidebarForAllProps) => {
    const { sortBy, onSortByChange } = useSortBookmarks();
    const { shareFilter, onShareFilterChange } = useFilterBookmarks();
    const { searchText, onSearchTextChange } = useSearchBookmarks();
    const { onSetPage, currentPage, numberOfPages, setRowCount, skip, take } =
        usePagedResultsFromParams();
    const { bookmarks } = useAllBookmarksQuery({
        skip,
        take,
        sortBy,
        searchText,
        currentUserOnly:
            shareFilter === UserBookmarkShareFilterOption.PrivateOnly,
    });

    useEffect(() => {
        if (bookmarks?.bookmarksLength) {
            setRowCount(bookmarks?.bookmarksLength);
        }
    }, [bookmarks?.bookmarksLength, setRowCount]);

    return (
        <BookmarkDetailPageSidebar
            totalPages={numberOfPages}
            onSetPage={onSetPage}
            currentPage={currentPage}
            bookmarks={bookmarks?.bookmarks}
            headingText={t("allBookmarks")}
            headingIcon={Icons.BookmarkOutline}
            dropdowns={
                <>
                    <SortBy sort={sortBy} onChange={onSortByChange} />
                    <FilterByShareStatus
                        shareStatus={shareFilter}
                        onChange={onShareFilterChange}
                    />
                    <SearchBookmarks
                        searchText={searchText}
                        onChange={onSearchTextChange}
                    />
                </>
            }
        />
    );
};

export default SidebarForAll;
